import { Component, inject } from '@angular/core';

import { AuthService } from '~features/auth/auth.service';
import { BRAND } from '~global-constants/brand';

@Component({
  selector: 'app-contact-banner',
  imports: [],
  templateUrl: './contact-banner.component.html',
  styleUrl: './contact-banner.component.css',
})
export class ContactBannerComponent {
  readonly brand = BRAND;
  authService = inject(AuthService);
  isAdmin = this.authService.isAdmin();
}
